import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { Moneda } from "@/shared/types/moneda";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface SetMonedasRequestDetail{
    id?:string,
    nombre:string,
    simbolo:string,
    hidden:boolean
}

export interface SetMonedasRequest{
    details:SetMonedasRequestDetail[]
}

export async function setMonedas(request:SetMonedasRequest):Promise<Moneda[]>{
    await sleep(1000);
    const response = await api.post("monetizacion/monedas", request);
    return response.data;
}

export function useSetMonedasMutation(mutationConfig: MutationConfig<Moneda[], SetMonedasRequest> = {}){
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: setMonedas,
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["monetizacion", "monedas"] });
        },
    })
}

export interface SetMonedasMutationProps {
    mutationConfig?: MutationConfig<Moneda[], SetMonedasRequest>,
    children?: (mutationResult: MutationResult<Moneda[], SetMonedasRequest>) => ReactNode
}

export function SetMonedasMutation({
    mutationConfig,
    children
}: SetMonedasMutationProps) {
    const mutationResult = useSetMonedasMutation(mutationConfig);
    return children && children(mutationResult);
}